const iconAssets = {};
const removeExtensionFromFileName = (fileName) => fileName
    .split(".")
    .filter((_, index, array) => index !== array.length - 1)
    .join(".");
const formatFileNameToKey = (filename) => {
    const fileNameWithoutRelativeSymbol = filename.split("/").at(-1);
    const fileNameWithoutExtension = removeExtensionFromFileName(fileNameWithoutRelativeSymbol);
    return fileNameWithoutExtension;
};
if (import.meta.webpack) {
    // Webpack
    const iconFiles = import.meta.webpackContext("./icons/", { recursive: false, mode: "sync" });
    iconFiles
        .keys()
        .forEach((fileName) => (iconAssets[formatFileNameToKey(fileName)] = iconFiles(fileName)));
}
else {
    // Vite
    const isInModules = import.meta.url.includes("node_modules");
    let iconFiles = null;
    if (isInModules) {
        iconFiles = import.meta.glob("/../node_modules/@geome/shell-locator-icons/icons/*", {
            eager: true,
            query: "?url",
            import: "default",
            exhaustive: true,
        });
    }
    else {
        iconFiles = import.meta.glob("./icons/*", { eager: true, query: "?url", import: "default" });
    }
    Object.entries(iconFiles).forEach(([fileName, src]) => (iconAssets[formatFileNameToKey(fileName)] = src));
}
export default iconAssets;
